import { BackendModel, BackendService } from '../core/backend.service';
import { Producto } from '../productos/producto.model';
import { Imagen } from '../productos/imagen.model';
import { TipoImpresion } from '../productos/tipo-impresion/tipo-impresion.model';
import { Parametric } from '../cliente/parametric.model';
import { Logo } from '../cliente/logo.model';
import { Talle } from '../productos/talle/talle.model';
import { Tarifario } from './tarifario.model';
import { CategoriaAcuerdo } from './categoria-acuerdo.model';

export class ProductoAcuerdo extends BackendModel {

  static path = '/compras/producto-acuerdo/';

  producto: Producto;
  cantidadMax: number;
  cantidadMin: number;
  imagenes: Imagen[];
  logos: Logo[];
  colores: Parametric[];
  talles: Talle[];
  tarifario: Tarifario;
  cantidadComprada: number;
  total: number;
  observaciones: string;
  limiteMax: boolean;
  limiteMin: boolean;
  customizaLogos: boolean;
  categorias: CategoriaAcuerdo[];

  constructor(protected backendService: BackendService, model?: ProductoAcuerdo) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/producto-acuerdo.model.ts